module.exports = new __parcel__URL__("chrome-icon.f5fbabc6.svg").toString();